<template>
    <div>
        <div class="popup-active" v-if="showInside">
            <div class="popup-form" v-click-outside="closeEvent">
                <header class="popup-title">
                    <h2>Spara i kostschema</h2>
                    <svg @click="hide" class="icon popup-close">
                        <use xlink:href="#icon-close"></use>
                    </svg>
                </header>
                <form id="add-to-diet-schedule" method="POST" v-on:submit.prevent="submitForm" v-if="!prompt">
                    <div class="form-group">
                        <label>Titel</label>
                        <input type="text" name="Namn" v-model="propTitle" class="form-control" v-bind:class="{
                            'is-invalid': attemptSubmit && missingTitle
                        }" />
                        <div class="invalid-feedback">Detta fält är obligatoriskt.</div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-sm-6 meal-type form-group">
                            <label>Måltidstyp</label>
                            <select v-model="meal" class="input-select">
                                <option value="1">Frukost</option>
                                <option value="3">Lunch</option>
                                <option value="5">Middag</option>
                                <option value="8">Mellanmål</option>
                                <option value="0">Snacks / Övrigt</option>
                            </select>
                            <input type="hidden" name="Typ" :value="meal" class="form-control" />
                        </div>
                        <div class="col-xs-12 col-sm-6 form-group">
                            <label>Välj tid och datum</label>

                            <input type="datetime-local" class="form-control" v-if="state.isMobile"
                                v-model="dateTimeNative" />

                            <date-picker v-model="dateToShow" type="datetime" format="D MMMM YYYY HH:mm"
                                :clearable="false" :lang="lang" :class="{
                                    'is-invalid': attemptSubmit && missingDate
                                }" :append-to-body="false" :show-time-panel="showTimePanel"
                                @change="onChangeDatePicker" @open="onOpenDatepicker" @close="onCloseDatepicker">
                                <div slot="footer" class="actions-date">
                                    <button class="mx-btn mx-btn-text" @click="toggleTimeRangePanel">
                                        <calendar v-if="showTimePanel" />
                                        <timer v-if="!showTimePanel" />
                                    </button>
                                    <button class="mx-btn mx-btn-text" @click="empty">
                                        <trash />
                                    </button>
                                </div>
                            </date-picker>

                            <div class="invalid-feedback">Välj datum och tid</div>

                            <input type="hidden" name="datum" :value="formattedDateTime" />
                            <input type="hidden" name="timme" :value="formattedHour" />
                            <input type="hidden" name="minuter" :value="formattedMinute" />
                            <input type="hidden" name="ReceptID" :value="recipeId" class="form-control" />
                            <input type="hidden" name="kopiera_till_kostschema" value="ja" class="form-control" />
                        </div>
                    </div>
                    <button class="btn btn-primary">Spara i kostschema</button>
                </form>
                <span v-if="prompt">{{ prompt }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

import state from './../state.js';

import moment from 'moment';

import 'moment/min/locales';

import DatePicker from 'vue2-datepicker';

import 'vue2-datepicker/locale/sv';

import Calendar from './../icons/Calendar';

import Timer from './../icons/Timer';

import Trash from './../icons/Trash';

// https://www.npmjs.com/package/vue2-datepicker
// https://mengxiong10.github.io/vue2-datepicker/index.html#ValueType
// https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/

export default {
    mounted() {
        this.propTitle = this.title;
        this.dateTime = new Date();
    },

    components: {
        DatePicker,
        Calendar,
        Timer,
        Trash
    },

    props: ['id', 'title', 'recipeId'],

    data() {
        return {
            state,
            showInside: false,
            dateTime: null,
            dateTimeNative: moment().format('YYYY-MM-DDTHH:mm'),
            meal: 1,
            baseUrl: window.appConfig.public_url,
            prompt: false,
            attemptSubmit: false,
            currentEvent: null,
            dateToShow: new Date(), // "Sunday, February 14th 2010, 3:25:50 pm" ("dddd, MMMM Do YYYY, h:mm:ss a")
            showTimePanel: false,
            showTimeRangePanel: false,
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1
                },
                monthBeforeYear: false
            },

            propTitle: ''
        };
    },

    directives: {
        'click-outside': {
            priority: 700,

            bind: function (el, binding, vnode) {
                let self = vnode.context;

                self.currentEvent = () => self.closeEvent();

                el.addEventListener('click', (event) => {
                    event.stopPropagation();
                });

                document.body.addEventListener('click', (e) => self.currentEvent());

                $('body').addClass('lock');
            },

            unbind: function (el, binding, vnode) {
                el.removeEventListener('click', (event) => event.stopPropagation());

                document.body.removeEventListener('click', self.currentEvent);

                $('body').removeClass('lock');
            }
        }
    },

    computed: {
        dietScheduleForm: function () {
            return this.state.dietScheduleForm;
        },

        promptSuccess: function () {
            return 'Receptet har lagts till i ditt kostschema ' + this.formattedDateTime + '.';
        },

        promptError: function () {
            return 'Något gick fel! Försök igen.';
        },

        missingTitle: function () {
            return this.title === '';
        },

        missingDate: function () {
            return this.dateToShow === null;
        },

        validateFields: function () {
            return !this.missingTitle && !this.missingDate;
        },

        formattedDateTime: function () {
            if (this.dateTime === null) return '[null]';

            return moment(this.dateTime).format('YYYY-MM-DD HH:mm');
        },

        formattedHour: function () {
            if (this.dateTime === null) return '[null]';

            return moment(this.dateTime).format('HH');
        },

        formattedMinute: function () {
            if (this.dateTime === null) return '[null]';

            return moment(this.dateTime).format('mm');
        }
    },

    watch: {
        dietScheduleForm: function (newVal) {
            newVal ? this.show() : '';
        },

        dateTimeNative: function (newVal) {
            this.dateTime = moment(newVal);
        }
    },

    methods: {
        onChangeDatePicker: function (dateString, type) {
            this.dateTime = dateString;
        },

        onOpenDatepicker: function () {
            this.$nextTick(() => {
                document
                    .querySelector('.mx-datepicker-popup')
                    .addEventListener('click', (e) => e.stopPropagation());
            });
        },

        onCloseDatepicker: function () {
            this.showTimePanel = false;
        },

        toggleTimeRangePanel: function (e) {
            e.preventDefault();
            this.showTimePanel = !this.showTimePanel;
        },

        empty: function () {
            this.dateToShow = null;
        },

        show() {
            this.showInside = true;
        },

        hide() {
            this.showInside = false;
            this.state.dietScheduleForm = false;
        },

        submitForm(e) {
            this.attemptSubmit = true;

            if (!this.validateFields) return;

            axios
                .post(
                    this.baseUrl + '/includes/ajax/recept.asp',
                    $('#add-to-diet-schedule').serialize()
                )
                .then((response) => {
                    if (response.status == 200) {
                        this.prompt = this.promptSuccess;
                    }
                })
                .catch((error) => {
                    if (error) {
                        this.error = this.promptError;
                    }
                });
        },

        closeEvent() {
            this.hide();
            this.prompt = false;
            this.attemptSubmit = false;
        }
    }
};
</script>
